/* eslint-disable handle-callback-err */
<style lang='less' scoped>
.main {
  padding: 10px;
  box-sizing: border-box;
  background: #f3f3f3;
  .outer {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: auto;
    padding: 8px 10px;
    box-sizing: border-box;
    .content {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      background: #fff;
      padding: 24px 10px;
      box-sizing: border-box;
      .case {
        width: 200px;
        height: auto;
        background: #fff;
        .header {
          width: 100%;
          background: #fff;
          height: 48px;
          line-height: 48px;
          text-align: center;
        }
        .pic {
          width: 100%;
          background: #fff;
          height: auto;
          background: #e5e5e5;
          video {
            width: 200px;
            height: 100%;
            display: block;
          }
        }
      }
      .empty-box {
        width: 200px;
        height: 100%;
      }
      .customized {
        position: relative;
        width: auto;
        height: 400px;
        .header {
          width: 100%;
          height: 48px;
          line-height: 48px;
          text-align: center;
        }
        .content {
          width: 100%;
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          overflow: auto;
          .pic-module {
            width: 180px;
            // height: 348px;
            position: relative;
            // margin-right: 45px;
            margin-bottom: 30px;
            .logo {
              width: 100%;
              height: 40px;
              line-height: 40px;
              position: absolute;
              top: 110px;
              display: flex;
              justify-content: center;
              img {
                width: 36px;
                height: 40px;
              }
            }
            .org-name {
              width: 100%;
              height: 40px;
              text-align: center;
              position: absolute;
              top: 150px;
              color: #fff;
              font-size: 12px;
            }
            img {
              width: 100%;
              // height: 300px;
              display: block;
            }
            .choose {
              width: 100%;
              height: 48px;
              line-height: 48px;
            }
          }
          .empty-box {
            width: 45px;
            height: 100%;
          }
          .pic-module2 {
            width: 180px;
            height: 348px;
            position: relative;
            .logo {
              width: 100%;
              height: 40px;
              line-height: 40px;
              position: absolute;
              top: 110px;
              display: flex;
              justify-content: center;
              color: rgb(69, 69, 69);
              font-size: 12px;
              img {
                width: 36px;
                height: 40px;
              }
            }
            .org-name {
              width: 100%;
              height: 40px;
              text-align: center;
              position: absolute;
              top: 150px;
              font-size: 12px;
            }
            img {
              width: 100%;
              height: 300px;
              display: block;
            }
            .choose {
              width: 100%;
              height: 48px;
              line-height: 48px;
            }
          }
        }
      }
    }
    .showBanner {
      position: relative;
      width: 100%;
      height: 100%;
      .header {
        width: 100%;
        height: 48px;
        display: flex;
        .case {
          width: 240px;
          height: 100%;
          text-align: center;
          line-height: 48px;
          padding: 0 20px;
          box-sizing: border-box;
        }
        .loginButton {
          width: 72px;
          height: 36px;
        }
      }
      .content {
        width: 100%;
        height: auto;
        display: flex;
        background: #fff;
        padding: 20px 20px;
        box-sizing: border-box;
        .pic {
          width: 240px !important;
          height: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          background: #fff;
        }
        .list {
          width: auto;
          height: auto;
          padding: 0 32px;
          box-sizing: border-box;
          background: #fff;
          .header {
            width: 100%;
            height: 48px;
            display: flex;
            border-bottom: 1px #e5e5e5 solid;
            .name {
              width: 160px;
              height: 48px;
              line-height: 48px;
            }
            .name-id {
              width: 72px;
              height: 48px;
              line-height: 48px;
              text-align: center;
            }
            .nameLink {
              width: 300px;
              height: 48px;
              line-height: 48px;
              overflow: hidden;
            }
          }
          .lib {
            width: 100%;
            height: 48px;
            display: flex;
            border-bottom: 1px #e5e5e5 solid;
            .tab {
              position: relative;
              width: 160px;
              height: 48px;
              line-height: 48px;
              overflow: hidden;
              img {
                width: 72px !important;
                height: 46px !important;
                padding: 5px 0;
                box-sizing: border-box;
                background: #fff;
              }
            }
            .name-id {
              width: 72px;
              height: 48px;
              line-height: 48px;
              text-align: center;
            }
            .link {
              width: 300px;
              height: 48px;
              line-height: 48px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .operation {
              width: 160px;
              height: 48px;
              display: flex;
              button {
                margin-right: 20px;
                height: 32px;
                width: 70px;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }
  }
  .create-new {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: auto;
    overflow: auto;
    padding: 20px 30px;
    box-sizing: border-box;
    z-index: 9999;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      line-height: 48px;
      font-weight: 600;
      .back {
        width: 72px;
        height: 48px;
      }
      .message {
        width: 98px;
        height: 48px;
        text-align: center;
        line-height: 36px;
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: auto;
      background: #fff;
      .cutBtn {
        width: 100%;
        padding: 12px 0;
        box-sizing: border-box;
      }
      .uploadMyFile {
        width: 280px;
      }
      .message {
        width: 100%;
        height: 30px;
        color: #949494;
        line-height: 30px;
      }
      .cropper-content {
        .cropper {
          width: 520px;
          height: 320px;
        }
      }
    }
  }
}
</style>
<template>
  <div class="main">
    <Modal
      title="提示"
      v-model="showRemove"
      @on-ok="Remove"
      class-name="vertical-center-modal"
    >
      <p>此操作将会禁用该banner，是否继续？</p>
    </Modal>
    <div
      class="outer"
      v-show="myHomePage"
    >
      <Tabs type="card">
        <Tab-pane label="启动页">
          <!-- 启动页 -->
          <div class="content">
            <div class="case">
              <div class="header">启动页案例</div>
              <div class="pic">
                <video
                  autoplay
                  muted
                  loop
                  style="width: 200px"
                >
                  <source src="https://cdn.qupeiyin.cn/2019-09-11/Fvtl8tRcYSvguEYh_W9Bhf9uCXDW.mp4">
                </video>
              </div>
            </div>
            <div class="empty-box" />
            <div class="customized">
              <div class="header">我的定制启动页</div>
              <div class="content">

                <div
                  class="pic-module"
                  v-for="(item,index) in templates"
                  :key="index"
                >
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div class="org-name">{{name}}</div>
                  <img :src="item.bg">
                  <div class="choose">
                    {{item.name}}
                    <i-button
                      v-if="templateType != item.id"
                      type="primary"
                      class="loginButton"
                      @click="SetTemplate(item.id)"
                    >选择</i-button>
                    <i-button
                      v-else
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>

                <!-- <div class="pic-module1">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div class="org-name">{{name}}</div>
                  <img :src="bannerOne">
                  <div class="choose">
                    模板一
                    <i-button
                      v-show="templateType != 1 || pic == ''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(1,templateTypeOne)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 1 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>
                <div class="empty-box" />
                <div class="pic-module2">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div class="org-name">{{name}}</div>
                  <img :src="bannerTwo">
                  <div class="choose">
                    模板二
                    <i-button
                      v-show="templateType != 2 || pic==''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(2,templateTypeTwo)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 2 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>
                <div class="empty-box" />
                <div class="pic-module1">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div class="org-name">{{name}}</div>
                  <img src="https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-03.jpg">
                  <div class="choose">
                    模板三
                    <i-button
                      v-show="templateType != 3 || pic == ''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(3,templateTypeThree)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 3 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>
                <div class="empty-box" />
                <div class="pic-module1">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div class="org-name">{{name}}</div>
                  <img src="https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-04.jpg">
                  <div class="choose">
                    模板四
                    <i-button
                      v-show="templateType != 4 || pic == ''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(4,templateTypeFour)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 4 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>
                <div class="empty-box" />
                <div class="pic-module1">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div
                    class="org-name"
                    style="color: #111"
                  >{{name}}</div>
                  <img src="https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-05.png">
                  <div class="choose">
                    模板五
                    <i-button
                      v-show="templateType != 5 || pic == ''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(5,templateTypeFive)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 5 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div>
                <div class="empty-box" />
                <div class="pic-module1">
                  <div class="logo">
                    <img :src="logo">
                  </div>
                  <div
                    class="org-name"
                    style="color: #111"
                  >{{name}}</div>
                  <img src="https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-06.png">
                  <div class="choose">
                    模板六
                    <i-button
                      v-show="templateType != 6 || pic == ''"
                      type="primary"
                      class="loginButton"
                      @click="StartOne(6,templateTypeSix)"
                    >选择</i-button>
                    <i-button
                      v-show="templateType == 6 && pic != ''"
                      class="loginButton"
                    >已启用</i-button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </Tab-pane>
        <Tab-pane label="banner">
          <!-- banner创建 -->
          <div class="showBanner">
            <div class="header">
              <div class="case">banner案例</div>
              <i-button
                type="primary"
                class="loginButton"
                style="margin-left: 48px;"
                @click="AddNew"
              >新建</i-button>
            </div>
            <div class="content">
              <div class="pic">
                <video
                  autoplay
                  muted
                  loop
                  style="width: 200px"
                >
                  <source src="https://cdn.qupeiyin.cn/2019-09-11/FquFe8oED0mfGnii75bRGYjlYzmf.mp4">
                </video>
              </div>
              <div class="list">
                <div class="header">
                  <div class="name-id">bannerID</div>
                  <div class="name">banner图片</div>
                  <div class="nameLink">banner链接</div>
                  <div class="name-id">排序</div>
                  <div class="name">操作</div>
                </div>
                <div
                  class="lib"
                  v-for="(item,index) in bannerList"
                  :key="index"
                >
                  <div class="name-id">{{item.id}}</div>
                  <div class="tab">
                    <img
                      class="pic"
                      :src="item.pic"
                    >
                  </div>
                  <div class="link">{{item.url}}</div>
                  <div class="name-id">{{item.sort}}</div>
                  <div class="operation">
                    <i-button
                      type="primary"
                      class="loginButton"
                      @click="EditBannerPopup(item.id, item.url, item.pic, item.sort)"
                    >编辑</i-button>
                    <i-button
                      type="primary"
                      v-show="item.status == 2"
                      class="loginButton"
                      @click="StartRemove(item.id,1)"
                    >启用</i-button>
                    <i-button
                      v-show="item.status == 1"
                      class="loginButton"
                      @click="tipsOfRemove(item.id,2)"
                    >禁用</i-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Tab-pane>
      </Tabs>
    </div>
    <!-- 创建banner -->
    <div
      class="create-new"
      v-show="createNew"
    >
      <div class="header">
        <Button
          @click="Reback"
          type="primary"
          style="height: 36px;"
        >
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="message">banner创建</div>
      </div>

      <div class="content">
        <div
          class="message"
          style="color: #111"
        >剪裁区域可通过鼠标滑轮调节背景图大小</div>
        <ImgCutter
          :boxWidth="800"
          :boxHeight="400"
          :ref="imgCutterModal"
          :cutWidth="450"
          :cutHeight="240"
          :sizeChange="false"
          v-on:cutDown="CutDown"
        />
        <div
          v-if="needUrl.length==0"
          class="message"
        >只能上传jpg/png文件，且不超过500kb</div>
        <div
          v-if="needUrl.length!=0"
          class="message"
        >banner预览</div>
        <div v-if="needUrl.length!=0">
          <img
            width="450px"
            :src="needUrl"
            alt
          >
        </div>
        <div
          style="margin-top: 10px"
          v-show="bannerLink"
        >
          <Input
            v-model="bannerUrl"
            placeholder="请输入banner链接地址"
            style="width: 300px;height: 42px;"
          />
        </div>
        <div
          style="margin-top: 10px;color: #949494"
          v-show="bannerLink"
        >
          banner排序，数字越小越靠前
          <br>
          <Input
            v-model="bannerRankList"
            placeholder="banner排序"
            style="width: 300px;height: 42px;"
          />
        </div>
        <Button
          v-show="bannerLink"
          @click="saveBanner"
          type="primary"
        >保存</Button>
      </div>
    </div>
    <!-- 编辑banner -->
    <div
      class="create-new"
      v-show="editBanner"
    >
      <div class="header">
        <Button
          @click="Reback"
          type="primary"
          style="height: 36px;"
        >
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="message">编辑banner</div>
      </div>
      <div class="content">
        <div
          class="message"
          style="color: #111"
        >剪裁区域可通过鼠标滑轮调节背景图大小</div>
        <ImgCutter
          :boxWidth="800"
          :boxHeight="400"
          :ref="imgCutterModal"
          :cutWidth="450"
          :cutHeight="240"
          :sizeChange="false"
          v-on:cutDown="CutDown"
        />
        <div
          v-if="needUrl.length==0"
          class="message"
        >只能上传jpg/png文件，且不超过500kb</div>
        <div
          v-if="needUrl.length!=0"
          class="message"
        >banner预览</div>
        <div v-if="needUrl.length!=0">
          <img
            width="450px"
            :src="needUrl"
            alt
          >
        </div>
        <div style="margin-top: 10px">
          <Input
            v-model="editUrl"
            :placeholder="editUrl"
            style="width: 450px;height: 42px;"
          />
        </div>
        <div style="margin-top: 10px">
          排序
          <br>
          <Input
            v-model="editUrlRank"
            :placeholder="editUrlRank"
            style="width: 450px;height: 42px;"
          />
        </div>
        <Button
          @click="EditBanner"
          type="primary"
        >保存</Button>
      </div>
    </div>
  </div>
</template>
<script>
import bannerOne from '@assets/banner_01.png'
import bannerTwo from '@assets/banner_02.png'
import brandApi from '@/lib/api/brand'
import analysisApi from '@lib/api/analysis'
import ImgCutter from 'vue-img-cutter'
import utilsTool from '@lib/utils'
export default {
  name: '',
  data() {
    return {
      organName: '',
      showRemove: false,
      imgSrc: '',
      rate: [7.5, 4],
      imgCutterModal: 'imgCutterModal',
      editBanner: false,
      myHomePage: true, // 主页显示开关
      editBannerId: '', // 被编辑banner的ID
      editUrl: '', // 被编辑banner的链接
      editPic: '', // banner被编辑之前的原图片
      editUrlRank: '', // 编辑banner排序
      bannerRankList: '', // 新建banner排序
      templateType: '',
      name: '', // 机构名称
      logo: '', // 机构logo
      removeBannerId: '', // 被移除的bannerID
      bannerOne: bannerOne, // 启动页1模板背景
      bannerTwo: bannerTwo, // 启动页2模板背景
      allInfo: {}, // 全部信息
      pic: '', // 机构所使用的启动页图片
      bannerLink: false, //
      shortName: '',
      message: '',
      list: 6,
      address: '',
      organTel: '',
      createNew: false,
      bannerList: [],
      bannerPicList: [],
      bannerUrlList: [],
      bannerStatus: '',
      bannerUrl: '', // banner链接跳转地址
      needUrl: '', // 剪裁之后生成的banner的图片地址
      // 裁剪组件的基础配置option
      option: {
        name: '',
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 450, // 默认生成截图框宽度
        autoCropHeight: 240, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [7.5, 4] // 截图框的宽高比例
      },
      isShowCropper: false, // 是否显示截图框
      fileUpload: null,
      UploadKey: '', // 返回的key值
      fileinfo: {},
      form: {},
      templateTypeOne: '', // 生成的启动页图片1地址
      templateTypeTwo: '', // 生成启动页图片2地址
      templateTypeThree: '',
      templateTypeFour: '',
      templateTypeFive: '',
      templateTypeSix: '',
      templates: [
        {
          bg: 'https://org.qupeiyin.com/img/banner_01.1a00fde0.png',
          isBlack: false,
          id: 1,
          name: '模板一'
        },
        {
          bg: 'https://org.qupeiyin.com/img/banner_02.55056637.png',
          isBlack: true,
          id: 2,
          name: '模板二'
        },
        {
          bg: 'https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-03.jpg',
          isBlack: false,
          id: 3,
          name: '模板三'
        },
        {
          bg: 'https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-04.jpg',
          isBlack: false,
          id: 4,
          name: '模板四'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-change.jpg',
          isBlack: true,
          id: 5,
          name: '模板五'
        },
        {
          bg: 'https://wapcdn.qupeiyin.cn/activity/newUserVip/banner-06.png',
          isBlack: true,
          id: 6,
          name: '模板六'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start1.png',
          isBlack: true,
          id: 7,
          name: '模板七'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start2.png',
          isBlack: true,
          id: 8,
          name: '模板八'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start3.png',
          isBlack: true,
          id: 9,
          name: '模板九'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start4.png',
          isBlack: true,
          id: 10,
          name: '模板十'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start5.png',
          isBlack: false,
          id: 11,
          name: '模板十一'
        },
        {
          bg:
            'https://wapcdn.qupeiyin.cn/business/brands/orgtemplate/start6.png',
          isBlack: false,
          id: 12,
          name: '模板十二'
        }
      ]
    }
  },
  created() {
    this.GetStartInfo()
    this.GetBannerInfo()
    this.GetOrganInfo()
  },
  components: {
    ImgCutter
  },
  methods: {
    // 获取机构信息
    GetOrganInfo() {
      analysisApi.GetOrgan().then(res => {
        const organInfo = res.data
        console.log(organInfo)
        this.name = organInfo.name
        this.logo = organInfo.startup_logo
        // this.GetStartPageType()
        // this.GetStartPageTypeTwo()
        // this.GetStartPageTypeThree()
        // this.GetStartPageTypeFour()
        // this.GetStartPageTypeFive()
        // this.GetStartPageTypeSix()
      })
    },
    // 新的剪裁方法
    CutDown: function(res) {
      const showPicId = Math.floor(Math.random() * (100 - 0) + 0)
      const dayTime = `${new Date().getTime()}-${showPicId}.jpg`
      this.imgSrc = res.dataURL
      console.log(this.imgSrc)
      const file = this.ConvertBase64UrlToBlob(this.imgSrc)
      // file.name = this.fileUpload.name
      // 将剪裁后的图片执行上传
      this.UploadBanner(file, dayTime)
    },
    // 剪裁图片
    CutBanner() {
      // 获取cropper的截图的base64 数据
      this.$refs.cropperNew.getCropData(data => {
        console.log(data)
        this.fileinfo.url = data
        this.isShowCropper = false
        // 先将显示图片地址清空，防止重复显示
        this.needUrl = ''
        this.bannerPicList = []
        this.bannerUrlList = []
        // 将剪裁后base64的图片转化为file格式
        const file = this.ConvertBase64UrlToBlob(data)
        // file.name = this.fileUpload.name
        // 将剪裁后的图片执行上传
        this.UploadBanner(file)
      })
    },
    // 将base64的图片转换为file文件
    ConvertBase64UrlToBlob(urlData) {
      const arr = urlData.split(',')
      const data = window.atob(arr[1])
      const mime = arr[0].match(/:(.*?);/)[1]
      const ia = new Uint8Array(data.length)
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
      }
      const blob = new Blob([ia], { type: mime })
      return new window.File([blob], this.option.name, { type: mime })
    },
    AddNew() {
      this.myHomePage = false
      this.createNew = true
      this.editBanner = false
      this.option.img = ''
      // this.$refs.cropperNew.refresh()
      this.needUrl = ''
      this.bannerUrl = ''
      this.bannerPicList = []
      this.bannerUrlList = []
    },
    // 编辑banner
    EditBannerPopup(id, url, pic, sort) {
      this.myHomePage = false
      this.editBanner = true
      this.editBannerId = id
      this.editUrl = url
      this.editUrlRank = sort
      this.editPic = pic
      // 清空上传banner时的数据
      // this.$refs.cropperEdit.refresh()
      this.needUrl = ''
      this.bannerUrl = ''
      this.bannerPicList = []
      this.bannerUrlList = []
      this.needUrl = pic
      console.log(this.needUrl)
    },
    EditBanner() {
      brandApi
        .EditBanner({
          id: this.editBannerId,
          pic: this.needUrl.slice(30),
          url: this.editUrl,
          sort: this.editUrlRank
        })
        .then(res => {
          if (res.status == 1) {
            // this.needUrl = ""
            this.bannerUrl = ''
            this.bannerPicList = []
            this.bannerUrlList = []
            this.option.img = ''
            this.$Message.info('修改成功')
            this.GetBannerInfo()
          } else {
            alert(res.msg)
          }
        })
    },
    Reback() {
      this.myHomePage = true
      this.editBanner = false
      this.createNew = false
    },
    UploadBanner(file, name) {
      utilsTool.UploadPic({
        file,
        name,
        success: res => {
          this.bannerPicList.push(file)
          console.log(this.bannerPicList)
          // this.bannerUrlList.push(res)
          this.bannerUrlList.push({
            name: res.fileName,
            url: res.url
          })
          console.log('上传', this.bannerUrlList)
          this.linkUrl = this.bannerUrlList[0]
          this.needUrl = res.url
          this.UploadKey = res.fileName
          console.log(this.needUrl)
          this.$Message.info('上传成功')
          this.bannerLink = true
        },
        fail: err => {
          console.log(err)
        }
      })
    },
    AddBanner(file) {
      console.log(file)
      this.option.name = file.name
      const fileReader = new FileReader()
      const that = this
      fileReader.onload = function(e) {
        // target.result 该属性表示目标对象的DataURL
        that.option.img = e.target.result
      }
      fileReader.readAsDataURL(file)
      return false
    },
    SetTemplate(id) {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/${id}?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/${id}?name=${this.name}&logo=${this.logo}`,
          selector: '.start'
        })
        .then(result => {
          const preview = result.data.poster_path
          brandApi
            .SetStartPage({
              pic: preview,
              template: id
            })
            .then(res => {
              if (res.status == 1) {
                this.GetStartInfo()
                this.$Message.info('修改成功')
              } else {
                alert(res.msg)
              }
            })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 使用模板一
    StartOne(id, type) {
      console.log(id, type)
      brandApi
        .SetStartPage({
          pic: type,
          template: id
        })
        .then(res => {
          if (res.status == 1) {
            this.GetStartInfo()
            this.$Message.info('修改成功')
          } else {
            alert(res.msg)
          }
        })
    },
    // 使用模板二
    StartTwo(id, type) {
      console.log(id, this.templateTypeTwo)
      brandApi
        .SetStartPage({
          pic: this.templateTypeTwo,
          template: id
        })
        .then(res => {
          if (res.status == 1) {
            this.GetStartInfo()
            this.$Message.info('修改成功')
          } else {
            alert(res.msg)
          }
        })
    },
    tipsOfRemove(id, type) {
      this.removeBannerId = id
      this.showRemove = true
      this.bannerStatus = type
    },
    // 移除banner
    Remove() {
      console.log(this.bannerStatus)
      brandApi
        .DeleteBanner({
          id: this.removeBannerId,
          type: this.bannerStatus
        })
        .then(res => {
          if (res.status == 1) {
            this.GetBannerInfo()
            this.$Message.info('设置成功')
          } else {
            this.$Message.info(res.msg)
          }
        })
    },
    // 启用banner
    StartRemove(id, type) {
      brandApi
        .DeleteBanner({
          id: id,
          type: type
        })
        .then(res => {
          if (res.status == 1) {
            this.GetBannerInfo()
            this.$Message.info('设置成功')
          } else {
            this.$Message.info(res.msg)
          }
        })
    },
    // 新建banner保存
    saveBanner() {
      brandApi
        .AddBanner({
          pic: this.UploadKey,
          url: this.bannerUrl,
          sort: this.bannerRankList
        })
        .then(res => {
          if (res.status == 1) {
            this.UploadKey = ''
            this.bannerUrl = ''
            this.bannerPicList = []
            this.bannerUrlList = []
            alert('设置成功')
            this.GetBannerInfo()
          } else {
            alert(res.msg)
          }
        })
    },
    // 获取启动页信息
    GetStartInfo() {
      brandApi.GetBrandInfo({}).then(res => {
        console.log(11)
        const allInfo = res
        console.log(allInfo)
        this.pic = allInfo.data.pic
        this.templateType = allInfo.data.template
      })
    },
    // 获取banner信息
    GetBannerInfo() {
      brandApi.GetBanner({}).then(res => {
        console.log(res)
        const allInfo = res
        this.bannerList = allInfo.data
      })
    },
    RemoveBanner(file, fileList) {
      console.log(file, fileList)
    },
    GetStartPageType() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/1?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/1?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlOne = result.data.poster_path
          this.templateTypeOne = imgUrlOne
        })
        .catch(err => {
          console.log(err)
        })
    },
    GetStartPageTypeTwo() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/2?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/2?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlTwo = result.data.poster_path
          this.templateTypeTwo = imgUrlTwo
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {})
    },
    GetStartPageTypeThree() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/3?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/3?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlThree = result.data.poster_path
          this.templateTypeThree = imgUrlThree
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {})
    },
    GetStartPageTypeFour() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/4?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/4?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlFour = result.data.poster_path
          this.templateTypeFour = imgUrlFour
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {})
    },
    GetStartPageTypeFive() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/5?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/5?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlFive = result.data.poster_path
          this.templateTypeFive = imgUrlFive
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {})
    },
    GetStartPageTypeSix() {
      brandApi
        .GetPoster({
          name: `start_templete_${new Date().getTime()}`,
          url: this.IsTest()
            ? `https://waptest.qupeiyin.cn/activity/newUserVip/preview/6?name=${this.name}&logo=${this.logo}`
            : `https://wap.qupeiyin.cn/activity/newUserVip/preview/6?name=${this.name}&logo=${this.logo}`
        })
        .then(result => {
          const imgUrlSix = result.data.poster_path
          this.templateTypeSix = imgUrlSix
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {})
    }
  }
}
</script>
